import React, { useState, useEffect, useRef } from 'react';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  Input,
  Row,
  Table,
  Col,
  Progress,
} from 'reactstrap';

import firebase from 'firebase';

import { useForm } from 'react-hook-form';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';

const AssignQuiz = ({ assignQuizData, handleClose, currentUser }) => {

  const [batchList, setBatchList] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [studentNotSelectedId, setStudentNotSelected] = useState([]);
  const [isAllBatchAssign, setIsAllBatchAssign] = useState(false);
  const [isAllStudentNotSelected, setIsAllStudentNotSelected] = useState(true);

  const isCheckAllBatchesAssigned = () => {
    try {
      console.log("batchListbatchList", batchList, selectedBatches);
      if (batchList.length == selectedBatches.length) {
        setIsAllBatchAssign(true);
      } else {
        setIsAllBatchAssign(false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const isCheckAllStudentNotSelected = ()=>{
    try {
      console.log(studentNotSelectedId, 'studentNotSelectedIdstudentNotSelectedId', studentList);
      if(studentNotSelectedId.length ==0){
        setIsAllStudentNotSelected(true)
      }else{
        setIsAllStudentNotSelected(false)
      }
    } catch (error) {
      console.log(error);
    }
  }

  const isAllStudentNotSelectedHandler = (isChecked)=>{
    try {
      let data = []
      if (isChecked){
        setIsAllStudentNotSelected(true)
      }else{
        data = studentList.map((item)=>{return item.id});
        setIsAllStudentNotSelected(false);
      }
      setStudentNotSelected(data)
      isNotSeletedStudentForBatch(data);
    } catch (error) {
      console.log(error);
    }
  }

  console.log(selectedBatches, 'selectedBatches');

  const getBatchList = async () => {
    try {
      document.querySelector('#loading-indicator').style.display = 'flex';
      console.log(currentUser, currentUser.isBatchManage,'assign currentUser');
      let querySnapshot
      if (currentUser.isTeacher){
        if (!currentUser?.isBatchManage){
          console.log('No Batch Exist For This Teacher');
          return
        }
        querySnapshot = await db
          .collection('Batch')
          .where('itemID', 'in', currentUser.isBatchManage)
          .orderBy('createdAt', 'desc')
          .get();
      }else{
        querySnapshot = await db
         .collection('Batch')
         .orderBy('createdAt', 'desc')
         .get();
      }
      const batches = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      console.log(batches,"batchesbatches");
      setBatchList(batches);
      document.querySelector('#loading-indicator').style.display = 'none';

    } catch (error) { 
    }
  };

  const handleSelectBatch = (checked, batchName, batchId) => {
    let data;
    if (checked) {
      data = [...selectedBatches, { batchId, batchName }];
    } else {
      data = selectedBatches?.filter((batch) => batch?.batchId !== batchId);
    }

    setSelectedBatches(data);
    saveQuizBatchesToDB(data);
    console.log('notselected length', data, data.length);

    if (data.length < 1) {
      console.log('notselected');
      setStudentList([]);
    }
    // getStudentList();
  };

  const getQuizBatches = async () => {
    try {
      // Fetch all quiz documents from the "AssignedQuizTests" collection
      const quizQuerySnapshot = await db.collection('AssignedQuizTests').get();
      let quizBatchesData = [];
      let quizData;
      // Iterate over each quiz document
      for (const quizDoc of quizQuerySnapshot.docs) {
        console.log(quizDoc.id, currentUser.isTeacher, batchList, assignQuizData?.quizId,"assignQuizData?.quizId");
        // if (currentUser.isTeacher ? batchList.  : quizDoc.id == assignQuizData?.quizId) {
        //   quizData = quizDoc.data();
        // }
        if (quizDoc.id === (currentUser.isTeacher ? assignQuizData?.quizId : assignQuizData?.quizId)) {
          quizData = quizDoc.data();
          console.log(quizData,"quizDataChwc");
        }
      }
      console.log(batchList,'accessbatchList');
      const batches = quizData?.batches || [];
      const formattedBatches = batches.map((batch) => ({
        batchName: batch.batchName,
        batchId: batch.batchId,
      }));

      setSelectedBatches(formattedBatches);
    } catch (error) {
      console.error('Error fetching quiz batches:', error);
    }
  };

  const saveQuizBatchesToDB = async (currentSelectedBatches) => {
    const quizDocRef = db
      .collection('AssignedQuizTests')
      .doc(assignQuizData?.quizId);

    // Prepare the quiz data with selected batches
    const quizData = {
      QuizTestId: assignQuizData?.quizId,
      status: 0, // 0 represents selected status
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      id: quizDocRef.id, // Add the document's ID to the quiz document
      batches: currentSelectedBatches.map((batch) => ({
        batchId: batch.batchId,
        batchName: batch.batchName,
        status: 0, // 0 represents selected
      })),
      batchIds: currentSelectedBatches.map((batch) => batch.batchId),
    };

    // Create or update the quiz document
    await quizDocRef.set(quizData, { merge: true });

    // Handle deselected batches if needed
    const previousBatchIds = currentSelectedBatches.map(
      (batch) => batch.batchId
    );

    // Batches that were previously selected but are now deselected
    const deselectedBatchIds = previousBatchIds.filter(
      (batchId) =>
        !currentSelectedBatches.map((batch) => batch.value).includes(batchId)
    );

    // Update the status of deselected batches if necessary
    if (deselectedBatchIds.length > 0) {
      await quizDocRef.update({
        batches: firebase.firestore.FieldValue.arrayRemove(
          ...deselectedBatchIds.map((batchId) => ({
            batchId,
            status: 1, // Mark as deselected
          }))
        ),
      });
    }
  };

  const selectedBatchIdExtractor = () => {
    return selectedBatches?.map((batch) => batch?.batchId);
  };

  let selectedBatchIds =
    selectedBatches?.length > 0 ? selectedBatchIdExtractor() : [];

  const getStudentList = async () => {
    try {
      const selectedBatchIds = selectedBatchIdExtractor();
      if (selectedBatchIds.length < 1) return [];
      const studentsRef = db.collection('zSystemStudents');

      const snapshot = await studentsRef
        .where('batch', 'array-contains-any', selectedBatchIds)
        .get();
      if (snapshot.empty) {
        return;
      }

      const students = snapshot.docs.map((doc) => {
        console.log(doc.data(), 'docData');
        let data = doc.data();
        return {
          id: doc.id,
          firstname: data?.firstname,
          lastname: data?.lastname,
          allQuizes: data?.quizTest,
          isAlreadyAssigned: data?.quizTest?.includes(assignQuizData?.quizId),
        };
      });
      console.log(students, 'docDataS');
      setStudentList(students);
    } catch (error) { }
  };

  const assignQuiz = async (currentStuId, selectedQuizTest) => {
    try {
      const studentRef = db.collection('zSystemStudents').doc(currentStuId);

      const studentDoc = await studentRef.get();
      if (!studentDoc.exists) {
        console.log('No such student!');
        return;
      }

      await studentRef.update({
        quizTest: selectedQuizTest,
      });

      getStudentList();
    } catch (error) { }
  };

  const isNotSeletedStudentForBatch = async (currentStuId, selectedQuizTest) => {
    try {
      console.log(assignQuizData?.quizId, "assignQuizData?.quizId");
      const quizRef = db.collection('QuizTest').doc(assignQuizData?.quizId);

      const studentDoc = await quizRef.get();
      if (!studentDoc.exists) {
        console.log('No such QuizTest Exist!');
        return false;
      }

      await quizRef.update({
        studentRemoved: currentStuId,
      });

      await getStudentList(); // Assuming this function is async

      return true;
    } catch (error) {
      console.error('Error updating student:', error);
      return false;
    }
  };


  // const handleChangeStudent = async (isChecked, currentStuId, quizes) => {
  //   let quizTestData = JSON.parse(JSON.stringify(quizes));
  //   if (isChecked) {
  //     quizTestData = [...quizTestData, assignQuizData?.quizId];
  //   } else {
  //     quizTestData = quizTestData?.filter(
  //       (quiz) => quiz !== assignQuizData?.quizId
  //     );
  //   }
  //   console.log(quizTestData);
  //   // debugger;
  //   assignQuiz(currentStuId, quizTestData);
  // };

  const handleChangeStudent = (checked, studentId) => {
    // getQuizOfStudent(studentId, checked);
    try {
      let data;
      console.log('checking', checked, studentId);
      if (!checked) {
        data = [...studentNotSelectedId, studentId];
      } else {
        data = studentNotSelectedId.filter((stuId) => stuId != studentId);
      }
      setStudentNotSelected(data || []);
      isNotSeletedStudentForBatch(data);
    } catch (error) { }
  };


  const setStudentNotSelectedHandler = async (quizId) => {
    try {
      const quizRef = db.collection('QuizTest').doc(quizId);
      const quizDoc = await quizRef.get();

      if (!quizDoc.exists) {
        console.log('No such QuizTest exists!');
        return;
      }
      const quizData = quizDoc.data();
      const studentRemoved = quizData?.studentRemoved || [];

      setStudentNotSelected(studentRemoved)
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    setStudentNotSelectedHandler(assignQuizData.quizId)
    getBatchList();
    getQuizBatches();
    isCheckAllBatchesAssigned();
    isCheckAllStudentNotSelected()
  }, []);
  

  useEffect(() => {
    getStudentList();
    isCheckAllBatchesAssigned();
  }, [selectedBatches]);

useEffect(()=>{
  isCheckAllBatchesAssigned()
},[batchList])

  useEffect(() => { 
    isCheckAllStudentNotSelected();
  }, [studentNotSelectedId])

  const BatchAllAssignHandler = async (isChecked) => {
    try {
      let data = [];
      if (isChecked) {
        setIsAllBatchAssign(true);
        data = batchList.map((item) => { return { batchId: item.itemID, batchName: item.batchName } });
      } else {
        setIsAllBatchAssign(false);
      }

      if (data.length < 1) {
        console.log('notselected');
        setStudentList([]);
      }
      
console.log(data,'isCheckingHandleData');
      setSelectedBatches(data);
      await saveQuizBatchesToDB(data);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div
      style={{
        backgroundColor: '#1f1e2e',
        height: '100%',
        overflowY: 'scroll',
      }}
    >

      <div style={{ padding: '5px 20px' }}>
        <Row style={{ justifyContent: 'flex-end' }}>
          <IconButton
            edge='start'
            style={{ color: 'white' }}
            onClick={handleClose}
            aria-label='close'
          >
            <CloseIcon />
          </IconButton>
        </Row>
        <Row>
          <Col md='12' style={{ marginBottom: '20px' }}>
            <Card style={{ margin: 0 }}>
              <CardHeader>
                <h5 className='title'>{assignQuizData?.quizName}</h5>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col sm={6} style={{ borderRight: '1px solid #3d4356' }}>
                    <h5 className='title' style={{ paddingLeft: '20px' }}>
                      Batches
                    </h5>
                    <br></br>

                    <Table className='tablesorter'>
                      <thead className='text-primary'>
                        <tr>
                          <th>
                            <Input
                              type='checkbox'
                              style={{ position: 'unset', marginLeft: '0px', }}
                              checked={isAllBatchAssign}
                              onChange={(e) => { BatchAllAssignHandler(e?.target?.checked) }}
                            // onChange={(e) => {
                            //   handleSelectBatch(
                            //     e?.target?.checked,
                            //     item.batchName,
                            //     item.itemID
                            //   );
                            // }}
                            // checked={selectedBatchIds?.includes(
                            //   item?.itemID
                            // )}
                            /></th>
                          <th>Batch Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {batchList.map((item) => {
                          return (
                            <tr key={item.itemID}>
                              <td
                              // style={{ display: 'flex', paddingLeft: '20px' }}
                              >
                                <Input
                                  type='checkbox'
                                  style={{ position: 'unset', marginLeft: '0px', }}
                                  onChange={(e) => {
                                    handleSelectBatch(
                                      e?.target?.checked,
                                      item.batchName,
                                      item.itemID
                                    );
                                  }}
                                  checked={selectedBatchIds?.includes(
                                    item?.itemID
                                  )}
                                />
                              </td>
                              <td>{item.batchName}</td>
                              <td style={{ width: '200px' }}>{selectedBatchIds?.includes(item?.itemID) ? 'Assigned' : ''}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    <Button color='info' type='submit' 
                      onClick={handleClose}
                    >
                      Submit
                    </Button>
                  </Col>

                  <Col sm={6} style={{ borderRight: '1px solid #3d4356' }}>
                    <h5 className='title' style={{ paddingLeft: '20px' }}>
                      Students In selected Batches
                    </h5>
                    <br></br>
                    {studentList.length > 0 ?
                      <>
                        <Table className='tablesorter'>
                          <thead className='text-primary'>
                            <tr>
                              <th>
                                <Input
                                  type='checkbox'
                                  style={{ position: 'unset', marginLeft: '0px', }}
                                onChange={(e) => {
                                 isAllStudentNotSelectedHandler(e?.target?.checked)
                                }}
                                checked={isAllStudentNotSelected}
                                />
                              </th>
                              <th>Student Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            {studentList.map((item) => {
                              return (
                                <tr key={item.id}>
                                  <td
                                  // style={{ display: 'flex' }}
                                  >
                                    <Input
                                      type='checkbox'
                                      style={{ position: 'unset', marginLeft: '0px', }}
                                      onChange={(e) => {
                                        handleChangeStudent(
                                          e?.target?.checked,
                                          item.id,
                                          item?.allQuizes
                                        );
                                      }}
                                      checked={!studentNotSelectedId.includes(item.id)}
                                    />
                                  </td>
                                  <td>{item.firstname + ' ' + item.lastname}</td>
                                  <td style={{ width: '200px' }}>{!studentNotSelectedId.includes(item.id) ? 'Assigned' : ''}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </> :
                      <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "80%",
                        color: 'rgb(82, 95, 127)',
                        fontSize: "15px",
                        fontWeight: "bold"
                      }}>
                        No batch is selected, or no students exist in this batch.
                      </div>
                    }
                  </Col>
                </Row>
                <br></br>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AssignQuiz;
